export default {"src":"/_next/static/media/joomla.2b8c2687.svg","height":60,"width":294,"blurWidth":0,"blurHeight":0};